var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shareWechat),expression:"shareWechat"}],staticClass:"c-popup-share-tip"},[_c('div',{staticClass:"share-msg"},[_c('div',{staticClass:"share-close",on:{"click":_vm.handleClose}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }